<template>
    <div class="header">
        <div class="l-container">
            <div
                class="header-logo cursor-pointer"
                @click="goToGateway"
            >
                <OhLogo />
            </div>
            <template v-if="!isMobile()">
                <div class="header-button-container">
                    <Button
                        v-if="showRegisterButton"
                        @click="register"
                        class="button-secondary"
                        data-cy="button-register"
                    >
                        {{t("register")}}
                    </Button>
                    <Button
                        @click="login"
                        class="button-secondary"
                        data-cy="button-login"
                    >
                        {{t("login")}}
                    </Button>
                </div>
            </template>
            <template v-else>
                <MobileMenu
                    v-if="isMobile()"
                    :loggedIn="loggedIn"
                    @register="register"
                    @login="login"
                    @logout="logout"
                />
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { getCurrentInstance, onMounted, ref, defineProps, withDefaults, onRenderTriggered } from "vue";
    import { useI18n } from "vue-i18n";
    import { createAuthenticationService } from "@/services/authenticationService";
    import MobileMenu from "@/components/MobileMenu.vue";
    import { useRouter } from "vue-router";
    import { OhLogo } from "@onehiring/ui/icons";

    withDefaults(defineProps<{ showRegisterButton: boolean } > (), {
        showRegisterButton: false
    });

    const app = getCurrentInstance();
    const { t } = useI18n();
    const loggedIn = ref(false);
    const router = useRouter();

    const isMobile = () => window.innerWidth <= 639;


    const register = async () => {
        const authService = createAuthenticationService(app);
        authService.openRegistrationDialog(null);
    }
    const login = async () => {
        const authService = createAuthenticationService(app);
        authService.openLoginDialog(null);
    }
    const logout = async () => {
        const authService = createAuthenticationService(app);
        await authService.signOut();
        loggedIn.value = false;
    }
    const goToGateway = () => {
       router.push({ name: 'Home' });
    }

    const getLoginState = async () => {
        const authService = createAuthenticationService(app);
        loggedIn.value = authService.isAuthenticated();
    }

    onMounted(async () => {
        getLoginState();
    })

    onRenderTriggered(async () => {
        setTimeout(getLoginState, 500);
    })

</script>

<style scoped>
    .header-logo {
        height: 1.25rem;
        width: 9.375rem;
    }
    .header-button-container {
        display: flex;
        align-items: center;
        gap: 1rem;
    }
</style>
